import { render, staticRenderFns } from "./modalAdd.vue?vue&type=template&id=340fc20e&"
import script from "./modalAdd.vue?vue&type=script&lang=js&"
export * from "./modalAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports